(function () {
  'use strict';

  if (window.__pocProductCardInitialized) return;
  window.__pocProductCardInitialized = true;

  function hydrateGallery(container) {
    if (!container || container.dataset.pocGalleryHydrated === 'true') return;

    const galleryData = container.querySelector('[data-poc-gallery-data]');
    const wrapper = container.querySelector('.image-wrapper');

    if (!galleryData || !wrapper) {
      container.dataset.pocGalleryHydrated = 'true';
      return;
    }

    let images = [];

    try {
      images = JSON.parse(galleryData.textContent || '[]');
    } catch (error) {
      console.warn('POC product card gallery data could not be parsed.', error);
    }

    images.forEach((imageData) => {
      if (!imageData || !imageData.src) return;

      const image = document.createElement('img');
      image.src = imageData.src;
      if (imageData.srcset) image.srcset = imageData.srcset;
      if (imageData.sizes) image.sizes = imageData.sizes;
      if (imageData.width) image.width = Number(imageData.width);
      if (imageData.height) image.height = Number(imageData.height);
      image.alt = imageData.alt || '';
      image.className = 'product-img';
      image.dataset.index = String(imageData.index);
      image.loading = 'lazy';
      image.decoding = 'async';
      wrapper.appendChild(image);
    });

    container.dataset.pocGalleryHydrated = 'true';
    galleryData.remove();
  }

  function moveSlide(trigger, direction) {
    const container = trigger.closest('.image-container');
    if (!container) return;

    hydrateGallery(container);

    const images = Array.from(container.querySelectorAll('.product-img'));
    const dots = container.querySelectorAll('.dot');

    if (!images.length) return;

    let activeIndex = images.findIndex((image) => image.classList.contains('active'));
    if (activeIndex === -1) activeIndex = 0;

    images[activeIndex].classList.remove('active');

    const nextIndex = (activeIndex + direction + images.length) % images.length;
    images[nextIndex].classList.add('active');

    dots.forEach((dot) => dot.classList.remove('active'));
    dots[nextIndex]?.classList.add('active');
  }

  function updateMobileSwipeDots(wrapper) {
    if (!wrapper.offsetWidth) return;

    const container = wrapper.closest('.image-container');

    if (wrapper.scrollLeft > 2) {
      hydrateGallery(container);
    }

    const index = Math.round(wrapper.scrollLeft / wrapper.offsetWidth);
    const dots = container?.querySelectorAll('.dot');

    dots?.forEach((dot) => dot.classList.remove('active'));
    dots?.[index]?.classList.add('active');
  }

  function setLoading(button, state) {
    if (!button) return;

    button.style.opacity = state ? '0.5' : '1';
    button.style.pointerEvents = state ? 'none' : 'auto';
  }

  async function addToCart(button) {
    const variantId = button?.dataset.variantId;
    const quantity = Number.parseInt(button?.dataset.quantity || '1', 10) || 1;

    if (!button || !variantId || button.getAttribute('aria-disabled') === 'true') return;

    const cartDrawer = document.querySelector('cart-drawer');
    const cartSections =
      cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'
        ? cartDrawer
            .getSectionsToRender()
            .map((section) => section.id)
            .filter(Boolean)
        : ['cart-drawer', 'cart-icon-bubble'];

    setLoading(button, true);
    button.setAttribute('aria-disabled', 'true');

    try {
      /*
       * Match Dawn's native product-form request contract.
       * Shopify's routes.cart_add_url is normally /cart/add (without .js),
       * so sending JSON to it can return HTML on some storefront setups.
       * FormData + Accept: application/javascript consistently returns the
       * section-rendering JSON expected by cartDrawer.renderContents().
       */
      const config =
        typeof window.fetchConfig === 'function'
          ? window.fetchConfig('javascript')
          : {
              method: 'POST',
              headers: { Accept: 'application/javascript' },
            };

      config.headers = {
        ...(config.headers || {}),
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      };
      delete config.headers['Content-Type'];

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', String(quantity));
      formData.append('sections', cartSections.join(','));
      formData.append('sections_url', window.location.pathname || '/');
      config.body = formData;

      if (cartDrawer && typeof cartDrawer.setActiveElement === 'function') {
        cartDrawer.setActiveElement(button);
      }

      const cartAddUrl =
        window.routes?.cart_add_url ||
        `${window.Shopify?.routes?.root || '/'}cart/add`;

      const response = await fetch(cartAddUrl, config);
      const responseText = await response.text();
      let data;

      try {
        data = JSON.parse(responseText);
      } catch (parseError) {
        console.error('POC cart returned non-JSON content.', {
          url: response.url,
          status: response.status,
          contentType: response.headers.get('content-type'),
          preview: responseText.slice(0, 300),
        });
        throw new Error('Could not add this item to the cart. Please try again.');
      }

      if (!response.ok || data?.status) {
        throw new Error(data?.description || data?.message || 'Could not add this item to the cart.');
      }

      if (
        !cartDrawer ||
        typeof cartDrawer.renderContents !== 'function' ||
        !data?.sections ||
        typeof data.sections !== 'object' ||
        typeof data.sections['cart-drawer'] !== 'string'
      ) {
        window.location.assign(window.routes?.cart_url || `${window.Shopify?.routes?.root || '/'}cart`);
        return;
      }

      cartDrawer.classList.remove('is-empty');
      const rendered = cartDrawer.renderContents(data);

      if (rendered === false) {
        window.location.assign(window.routes?.cart_url || `${window.Shopify?.routes?.root || '/'}cart`);
      }
    } catch (error) {
      console.error('POC product card add-to-cart failed.', error);
      alert(error?.message || 'Could not add to cart.');
    } finally {
      button.removeAttribute('aria-disabled');
      setLoading(button, false);
    }
  }

  function updateVariant(select) {
    const option = select.options[select.selectedIndex];
    const card = select.closest('.custom-product-card');

    if (!option || !card) return;

    const variantId = option.value;
    const price = option.dataset.price;
    const compare = option.dataset.compare;
    const priceBox = card.querySelector('.product-price');

    if (!priceBox) return;

    const priceElement = priceBox.querySelector('.current-price');
    const compareElement = priceBox.querySelector('.compare-price');

    if (priceElement) priceElement.textContent = price;

    if (compare) {
      if (compareElement) {
        compareElement.textContent = compare;
      } else {
        const span = document.createElement('span');
        span.className = 'compare-price';
        span.textContent = compare;
        priceBox.appendChild(span);
      }
    } else {
      compareElement?.remove();
    }

    const addToCartButton = card.querySelector('[data-poc-add-to-cart]');
    if (addToCartButton) {
      addToCartButton.dataset.variantId = variantId;
    }
  }

  function initRatings(root) {
    root.querySelectorAll('.product-rating').forEach((element) => {
      if (element.innerHTML.trim()) return;

      const rating = (Math.random() * 1.2 + 3.8).toFixed(1);
      const reviews = Math.floor(Math.random() * 250) + 15;
      const stars =
        '★'.repeat(Math.floor(rating)) +
        (rating % 1 >= 0.5 ? '½' : '') +
        '☆'.repeat(5 - Math.ceil(rating));

      element.innerHTML = `<span class="stars">${stars}</span><span class="reviews-count">(${reviews})</span>`;
    });
  }

  document.addEventListener('click', (event) => {
    const slideTrigger = event.target.closest('[data-poc-slide-direction]');

    if (slideTrigger) {
      event.preventDefault();
      event.stopPropagation();
      moveSlide(slideTrigger, Number(slideTrigger.dataset.pocSlideDirection));
      return;
    }

    const addToCartButton = event.target.closest('[data-poc-add-to-cart]');

    if (addToCartButton) {
      event.preventDefault();
      addToCart(addToCartButton);
    }
  });

  document.addEventListener('change', (event) => {
    const variantSelect = event.target.closest('[data-poc-variant-select]');
    if (variantSelect) updateVariant(variantSelect);
  });

  document.addEventListener(
    'scroll',
    (event) => {
      const wrapper = event.target;

      if (
        !(wrapper instanceof Element) ||
        !wrapper.classList.contains('image-wrapper') ||
        !wrapper.closest('.custom-product-card')
      ) {
        return;
      }

      updateMobileSwipeDots(wrapper);
    },
    true
  );

  document.addEventListener('shopify:section:load', (event) => {
    initRatings(event.target);
  });

  initRatings(document);
})();
